import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  FileField,
  usePermissions,
  useNotify,
} from "react-admin";

const CertificateCreate = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();

  if (
    !(
      permissions.includes("certificate.create") ||
      permissions.includes("certificate.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Create {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Certificate created successfully", {
            type: "success",
          })
        }
      >
        <TextInput
          source="course_name"
          label="Certificate-Type"
          required
        />

        <TextInput
          source="layout"
          multiline
          fullWidth
          required
        />

        <FileInput source="file" accept="application/pdf">
          <FileField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
};

export default CertificateCreate;